import {
	GA4EcommerceEventPayload,
	GA4EventPayload,
	GA4ItemDeliveryPDPEventPayload,
	GA4ItemDeliveryPLPEventPayload,
	GA4ItemDeliveryCartEventPayload,
	GA4ItemDeliveryCheckoutEventPayload,
	GA4PageLoadEvent,
	GA4SelectPromotionEventPayload,
	GA4ViewPromotionEventPayload,
} from 'presentation/events/types/ga4Types';
import { pushToDataLayer } from 'presentation/events/utils/ga4Utils';

export const triggerGA4EcommerceEvent = (
	payload:
		| GA4EcommerceEventPayload
		| GA4ViewPromotionEventPayload
		| GA4SelectPromotionEventPayload
		| GA4PageLoadEvent
		| GA4ItemDeliveryPDPEventPayload
		| GA4ItemDeliveryPLPEventPayload
		| GA4ItemDeliveryCartEventPayload
		| GA4ItemDeliveryCheckoutEventPayload,
	options?: { cleanup?: boolean; eventParams?: Readonly<Record<string, unknown>> }
) => {
	try {
		if (options?.cleanup) {
			pushToDataLayer({ ecommerce: null });
		}

		pushToDataLayer({
			...options?.eventParams,
			event: payload.event,
			ecommerce: payload.ecommerce,
		});
	} catch (error) {
		console.error(`Error triggering GA4 Ecommerce event "${payload.event}":`, error);
	}
};

export const triggerGA4Event = <T extends GA4EventPayload>(payload: T) => {
	try {
		pushToDataLayer({
			...payload,
		});
	} catch (error) {
		console.error(`Error triggering GA4 event "${payload.event}":`, error);
	}
};
